export default __webpack_public_path__ + "images/dt_c7cf7c2.svg";